import { HTMLAttributes } from 'react';

export type SkeletonVariant = 'text' | 'rect' | 'circle';

export interface SkeletonProps extends HTMLAttributes<HTMLDivElement> {
  variant?: SkeletonVariant;
  /** Szerokość (Tailwind klasa np. 'w-32' lub CSS wartość przez style.width). */
  width?: string;
  /** Wysokość (jak width). Dla text ignorowane. */
  height?: string;
  /** Ile linii dla variant='text'. Default 1. */
  lines?: number;
}

const BASE = 'bg-surface-hover/60 animate-pulse-slow';

/**
 * Placeholder box dla loading states. Dla list używaj w map() z kilkoma instancjami.
 * Tekst: renderuje `lines` paseczków, ostatni węższy (naturalny efekt).
 */
export function Skeleton({
  variant = 'rect',
  width,
  height,
  lines = 1,
  className,
  style,
  ...rest
}: SkeletonProps) {
  if (variant === 'text') {
    return (
      <div className={['space-y-2', className].filter(Boolean).join(' ')} {...rest}>
        {Array.from({ length: lines }).map((_, i) => {
          const isLast = i === lines - 1 && lines > 1;
          return (
            <div
              key={i}
              className={`${BASE} rounded h-3.5`}
              style={{ width: isLast ? '70%' : (width ?? '100%') }}
            />
          );
        })}
      </div>
    );
  }

  const variantClass = variant === 'circle' ? 'rounded-full' : 'rounded-lg';
  const inlineStyle: React.CSSProperties = { ...style };
  if (width && !className?.includes('w-')) inlineStyle.width = width;
  if (height && !className?.includes('h-')) inlineStyle.height = height;

  return (
    <div
      className={[BASE, variantClass, className].filter(Boolean).join(' ')}
      style={inlineStyle}
      {...rest}
    />
  );
}
